export default function SiteFooter() {
  const links = [
    { id: "live", label: "正在发生" },
    { id: "timeline", label: "新瓜时间线" },
    { id: "scene", label: "第一现场" },
    { id: "trust", label: "报法与 FAQ" },
  ];

  return (
    <footer className="mt-16 border-t border-line bg-accent-soft/60 md:mt-24">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-sm">
            <div className="flex items-end gap-0.5">
              <span className="font-display text-3xl font-black leading-none text-ink">911</span>
              <span className="font-display text-lg font-semibold leading-none text-accent">网</span>
            </div>
            <p className="mt-3 text-sm leading-6 text-muted">
              突发消息与紧急爆料的第一站，为直接上第一轮现场的人准备。
            </p>
          </div>

          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                className="whitespace-nowrap text-sm text-ink transition-colors hover:text-accent"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-2 border-t border-line pt-5 text-xs text-muted sm:flex-row sm:items-center sm:justify-between">
          <span>© 911网 · 本页为演示占位内容，不指向真实事件，仅作视觉呈现。</span>
          <span>进站看到的每一条，都是还在现场动的那一刻。</span>
        </div>
      </div>
    </footer>
  );
}